<template>
  <page layout="tabbed">
    <page-header-new :title="pageTitle" :breadcrumbs="breadcrumbs" />
    <page-tabs :tabs="tabs">
      <router-view slot="router" />
    </page-tabs>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'DataRetentionPage',

  components: {
    Page,
    PageHeaderNew,
    PageTabs
  },

  computed: {
    pageTitle() {
      return (
        this.$store.getters.embeddedTitle || this.$t(this.$route.meta.title)
      )
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('Settings_Breadcrumb_Settings')
        },
        {
          label: this.$t('LeftNavigation_Advanced')
        },
        {
          label: this.pageTitle
        }
      ]
    },

    canViewAuditLog() {
      return this.$can('DataRetention:AuditAccess')
    },

    tabs() {
      const items = [
        {
          title: this.$t('DataRetention_Tab_Overview'),
          route: projectRoute({ name: 'DataRetentionOverview' })
        },
        {
          title: this.$t('DataRetention_Tab_Policies'),
          route: projectRoute({ name: 'DataRetentionPolicies' })
        },
        {
          title: this.$t('DataRetention_Tab_History'),
          route: projectRoute({ name: 'DataRetentionHistory' })
        }
      ]

      if (this.canViewAuditLog) {
        items.push({
          title: this.$t('DataRetention_Tab_AuditLog'),
          route: projectRoute({ name: 'DataRetentionAuditLog' })
        })
      }

      return items
    }
  }
}
</script>

<style lang="scss">
.custom-confirm.data-retention-save-confirm {
  width: 540px;

  .msg-text {
    white-space: pre-line;
  }

  .icon {
    color: #e6a23c;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/pages/DataRetentionPage.vue